<template>
  <div
    v-if="image && (image.sizes || {}).large"
    class="ArticleComp relative w-full bg-black bg-full"
    :style="{
      paddingBottom: '56.25%',
      backgroundImage: `url('${image.sizes.large}')`
    }"
    role="img"
    :aria-label="image.title"
    :title="image.title"
  />
</template>

<script>

export default {
  name: 'Article',

  props: {
    post: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    image() { return this.post.header_image }
  }
}
</script>
